import React from 'react';
import {PlayersDashboard as ClassicPlayersDashboard} from './classic';

const PlayersDashboard = {
    get(sportConfig) {
        if (sportConfig.isGameTypeClassic()) {
            return ClassicPlayersDashboard;
        }

        throw new Error(`get ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {PlayersDashboard};
